import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "/gift-vouchers/search",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const clientGiftVoucher = require("./ClientGiftVoucher").default;
          cb(null, clientGiftVoucher);
        },
        "ClientGiftVoucher"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/ClientGiftVouchers/index.js